module.exports = __webpack_public_path__ + "static/prozessdiagramm1-a2036261773346eec3c2c94d504abac0.png";